export const customStyles = {
  container: (provided: any, state: any) => ({
    ...provided,
    width: 295,
    height: 38,
  }),
};
